import React from 'react'

// Hooks
import usePageZoom from 'modules/shares/PageCanvasView/hooks/usePageZoom'

// Local Components
import PublicationPageSelector from '../PublicationPageSelector'

// Styles
import { StyledZoom } from './PublicationCanvasControls.styles'

// Types
import { PublicationPageFragment } from '@sketch/gql-types'

interface PublicationCanvasControlsProps {
  identifier: string
  page: PublicationPageFragment
  onPageSelected: (page: PublicationPageFragment) => void
}

const PublicationCanvasControls: React.FC<PublicationCanvasControlsProps> = ({
  identifier,
  page,
  onPageSelected,
}) => {
  const [zoom, setZoom] = usePageZoom()

  return (
    <>
      <PublicationPageSelector
        identifier={identifier}
        page={page}
        onPageSelected={onPageSelected}
      />
      <StyledZoom zoom={zoom} setZoom={setZoom} />
    </>
  )
}

export default PublicationCanvasControls
